import { render, staticRenderFns } from "./ZbtDelivery.vue?vue&type=template&id=3532e162&"
import script from "./ZbtDelivery.vue?vue&type=script&lang=js&"
export * from "./ZbtDelivery.vue?vue&type=script&lang=js&"
import style0 from "./ZbtDelivery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports